const initialState = {
    adminTab: '',
    users: {
        searchUsersList: [],
        userProfile: false,
    },
    logs: {
        data: [],
        pause: false
    }
};
  
export const admin = (state = initialState, action) => {
    switch (action.type) {
        case 'ADMIN_CHANGE_TAB': {
            return {
                ...state,
                adminTab: action.tab
            }
        }
        case 'ADMIN_USERS_SEARCH_LIST': {
            console.log('ADMIN_USERS_SEARCH_LIST');
            return {
                ...state,
                users: {
                    ...state.users,
                    searchUsersList: action.list
                }
            }
        }
        case 'ADMIN_USER_SET_PROFILE': {
            return {
                ...state,
                users: {
                    ...state.users,
                    userProfile: action.user
                }
            }
        }
        case 'ADMIN_CLOSE_PROFILE' : {
            return {
                ...state,
                users: {
                    ...state.users,
                    userProfile: false
                }
            }
        }
        case 'ADMIN_LOGS_PAUSE': {
            return {
                ...state,
                logs: {
                    ...state.logs,
                    pause: action.pause
                }
            }
        }
        default:
            return state;
    }
};